<template>
  <div class="profile-menu">
    <div class="login">
      <span class="name">{{ $auth.remember() }}</span>
      <span class="role wrap">
        <span
          v-if="apiSystemSettings?.enableUserLevels == '1' && isUsRole == 'user'"
          class="user-level"
        >
          <AuTooltip
            v-if="enableUserStatus"
            type="slot"
            :description="textTooltip"
          >
            <span>{{ level }}&nbsp;</span>
            <span>{{ role }}</span><span>{{ isSaleLeader }}</span>
          </AuTooltip>
          <span v-else>{{ role }}</span><span>{{ isSaleLeader }}</span>
        </span>
        <span
          v-else
          class="user-level"
        >{{ role }}
        </span>
        <span>{{ isSaleLeader }}</span>
      </span>
    </div>

    <div
      class="profile-menu__item"
      @click="openPage('user')"
      @mouseenter="user='user_hover'"
      @mouseleave="user='user'"
    >
      <AuIcon
        class="profile-menu__image"
        :icon="user"
      />
      {{ $t("profileMenu.profile") }}
    </div>

    <div
      class="profile-menu__item"
      @click="openPage('security')"
      @mouseenter="shield='shield_hover'"
      @mouseleave="shield='shield'"
    >
      <AuIcon
        class="profile-menu__image"
        :icon="shield"
      />
      {{ $t("profileMenu.security") }}
    </div>

    <div
      v-if="referralEnable"
      class="profile-menu__item"
      @click="openPage('referral program')"
      @mouseenter="referral='referral_hover'"
      @mouseleave="referral='referral'"
    >
      <AuIcon
        class="profile-menu__image"
        :icon="referral"
      />
      {{ $t("profileMenu.referralProgram") }}
    </div>

    <div
      class="profile-menu__item"
      @click="openPage('settings')"
      @mouseenter="gear='gear_hover'"
      @mouseleave="gear='gear'"
    >
      <AuIcon
        class="profile-menu__image"
        :icon="gear"
      />
      {{ $t("profileMenu.settings") }}
    </div>

    <div class="logout">
      <div
        class="profile-menu__item "
        @click="goToLogout"
        @mouseenter="logout='logout_hover'"
        @mouseleave="logout='logout'"
      >
        <AuIcon
          class="profile-menu__image"
          :icon="logout"
        />
        {{ $t("profileMenu.logout") }}
      </div>
    </div>
  </div>
</template>

<script>
import { checkAccess, scope } from "@/help/accessData";
import { mapGetters } from "vuex";

import isUserRole from "@/help/isUserRole";

export default {
  data() {
    return {
      user: "user",
      shield: "shield",
      gear: "gear",
      referral: "referral",
      logout: "logout"
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile/profile",
      apiSystemSettings: "apiSystemSettings"
    }),

    isUsRole() {
      return isUserRole();
    },

    isSaleLeader() {
      return this.profile?.isSaleLeader ? `${this.$t("profileMenu.leader")}` : "";
    },

    role() {
      switch (isUserRole()) {
        case "expert":
          return this.$t("profileMenu.expert");
        case "issuer":
          return this.$t("profileMenu.issuer");
        case "user":
          return process.env.VUE_APP_PLATFORM + " Member";
        default:
          return "Indefinite role";
      }
    },

    enableUserStatus() {
      return process.env.VUE_APP_ENABLE_USER_STATUSES == "true";
    },

    level() {
      return this.profile?.level.charAt(0).toUpperCase() + this.profile?.level.slice(1);
    },

    textTooltip() {
      return `${this.$t("profileMenu.status")} ${this.level}<br>${this.$t("profileMenu.points")} ${this.points}`;
    },

    referralEnable() {
      return checkAccess(scope.enableReferralSystem);
    }
  },
  methods: {
    goToLogout() {
      localStorage.removeItem("testRole");
      this.$router.push("/logout");
    },

    openPage(name) {
      this.$router.push({ name });
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-menu
{
  width: 245px;
  background-color: var(--menu-color);
  border: 1px solid var(--border-color);
  border-radius: 20px;
  padding: 20px 20px 0 20px;
  display: flex;
  flex-direction: column;
  z-index: 2500;

  &__item {
    font-size: 15px;
    color: var(--color-60);
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 7px;
    padding-bottom: 17px;

    &:hover {
      color: var(--text-color);
    }
    &:last-child {
      padding-bottom: 0;
    }
  }

  &__image {
    width: 20px;
    height: 20px;
  }

  &__profile {
    font-size: 13px;
  }
}

.logout {
  padding: 15px 0;
  border-top: 1px solid var(--color-30);
  cursor: pointer;
}
.login {
  display: none;
  padding-bottom: 15px;
  margin-bottom: 17px;
  .name {
    font-weight: 500;
    font-size: 14px;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: var(--text-color);
  }
  .role {
    font-weight: 400;
    font-size: 12px;
    color: var(--color-50);
  }
  @media screen and (max-width: 640px) {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid var(--color-30);
  }
}
.user-level {
  text-transform: capitalize;
  margin-right: 2px;
}
</style>